(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coupon"] && !Shopify.designMode) return;
  try {
    
    let copyText = document.querySelector(".copy-text");
    copyText.querySelector("button").addEventListener("click", function () {
  	let input = copyText.querySelector("input.text");
  	input.select();
  	document.execCommand("copy");
  	copyText.classList.add("active");
  	window.getSelection().removeAllRanges();
  	setTimeout(function () {
  		copyText.classList.remove("active");
  	}, 2500);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp--product-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pdp-product-carousel')) {
  customElements.define('pdp-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.viewport = this.querySelector('.pdpc-viewport');
      if (!this.viewport) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.pdpc-track');
      this.featured = this.querySelector('.pdpc-featured');
      this.allSlides = Array.from(this.querySelectorAll('[data-pdpc-slide]'));
      this.firstSlide = this.querySelector('[data-related-shot]');
      this.controls = this.querySelector('.pdpc-controls');
      this.dots = this.querySelector('.pdpc-dots');
      this.desktop = matchMedia('(min-width: 1280px)');
      this.positions = [];
      this.active = 0;
      this.targetIndex = null;
      this.querySelector('[data-prev]').addEventListener('click', () => this.go((this.targetIndex ?? this.active) - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go((this.targetIndex ?? this.active) + 1), options);
      this.dots.addEventListener('click', event => {
        const dot = event.target.closest('[data-position]');
        if (dot) this.go(Number(dot.dataset.position));
      }, options);
      this.viewport.addEventListener('scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => { this.targetIndex = null; this.update(); }, 160);
      }, { ...options, passive: true });
      this.viewport.addEventListener('wheel', () => { this.targetIndex = null; }, { ...options, passive: true });
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = this.targetIndex ?? this.active;
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.positions.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      // Native touch/trackpad scrolling remains free; mouse dragging follows the pointer.
      this.viewport.addEventListener('pointerdown', event => {
        this.targetIndex = null;
        this.suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.controls.hidden) return;
        this.viewport.scrollTo({ left: this.viewport.scrollLeft, behavior: 'instant' });
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.viewport.scrollLeft, moved: false };
      }, options);
      this.viewport.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(event.clientY - drag.y) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.viewport.setPointerCapture(event.pointerId);
          this.viewport.classList.add('is-dragging');
        }
        event.preventDefault();
        this.viewport.scrollLeft = drag.left - dx;
      }, options);
      const finishDrag = event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        this.suppressClick = this.drag.moved;
        this.drag = null;
        this.viewport.classList.remove('is-dragging');
        if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
      };
      window.addEventListener('pointerup', finishDrag, options);
      window.addEventListener('pointercancel', finishDrag, options);
      this.viewport.addEventListener('lostpointercapture', finishDrag, options);
      this.viewport.addEventListener('dragstart', event => event.preventDefault(), options);
      this.viewport.addEventListener('click', event => {
        if (!this.suppressClick || event.detail === 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }, { ...options, capture: true });
      this.desktop.addEventListener('change', () => this.measure(), options);
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.viewport);
      this.allSlides.forEach(slide => this.observer.observe(slide));
      this.measure();
    }
    offset(slide) {
      return slide.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left + this.viewport.scrollLeft;
    }
    measure() {
      // Pin only the metafield-selected shot; move that same card into the row on smaller screens.
      const parent = this.desktop.matches ? this.featured : this.track;
      if (this.firstSlide && this.firstSlide.parentElement !== parent) {
        parent.prepend(this.firstSlide);
        this.viewport.scrollTo({ left: 0, behavior: 'instant' });
        this.targetIndex = null;
      }
      this.featured.hidden = !this.desktop.matches || !this.firstSlide;
      this.slides = Array.from(this.track.querySelectorAll('[data-pdpc-slide]'));
      const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const positions = [];
      this.slides.forEach(slide => {
        const position = Math.min(max, Math.max(0, this.offset(slide)));
        if (!positions.length || position - positions[positions.length - 1] > 2) positions.push(position);
      });
      if (max > 2 && max - (positions[positions.length - 1] || 0) > 2) positions.push(max);
      this.positions = positions;
      this.controls.hidden = max <= 2 || positions.length < 2;
      this.viewport.classList.toggle('is-draggable', !this.controls.hidden);
      if (this.dots.children.length !== positions.length) {
        this.dots.replaceChildren(...positions.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pdpc-dot';
          dot.dataset.position = index;
          dot.setAttribute('aria-label', `Go to carousel position ${index + 1} of ${positions.length}`);
          dot.setAttribute('aria-controls', this.viewport.id);
          return dot;
        }));
      }
      this.update();
    }
    update() {
      this.active = this.positions.reduce((best, position, index) => Math.abs(position - this.viewport.scrollLeft) < Math.abs(this.positions[best] - this.viewport.scrollLeft) ? index : best, 0);
      Array.from(this.dots.children).forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.active)));
    }
    go(index, instant = false) {
      if (!this.positions.length) return;
      const target = (index + this.positions.length) % this.positions.length;
      this.targetIndex = target;
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => { this.targetIndex = null; this.update(); }, 800);
      this.viewport.scrollTo({ left: this.positions[target], behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.settleTimer);
      this.frame = 0;
      this.drag = null;
      this.viewport?.classList.remove('is-dragging');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipes--upsell-carousel"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('recipes-upsell-carousel')) {
  customElements.define('recipes-upsell-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.viewport = this.querySelector('.ruc-viewport');
      if (!this.viewport) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.ruc-track');
      this.allSlides = Array.from(this.querySelectorAll('[data-ruc-slide]'));
      this.controls = this.querySelector('.ruc-controls');
      this.dots = this.querySelector('.ruc-dots');
      this.positions = [];
      this.active = 0;
      this.targetIndex = null;
      this.querySelector('[data-prev]').addEventListener('click', () => this.go((this.targetIndex ?? this.active) - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go((this.targetIndex ?? this.active) + 1), options);
      this.dots.addEventListener('click', event => {
        const dot = event.target.closest('[data-position]');
        if (dot) this.go(Number(dot.dataset.position));
      }, options);
      this.viewport.addEventListener('scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => { this.targetIndex = null; this.update(); }, 160);
      }, { ...options, passive: true });
      this.viewport.addEventListener('wheel', () => { this.targetIndex = null; }, { ...options, passive: true });
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = this.targetIndex ?? this.active;
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.positions.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      // Native touch/trackpad scrolling remains free; mouse dragging follows the pointer.
      this.viewport.addEventListener('pointerdown', event => {
        this.targetIndex = null;
        this.suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.controls.hidden) return;
        this.viewport.scrollTo({ left: this.viewport.scrollLeft, behavior: 'instant' });
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.viewport.scrollLeft, moved: false };
      }, options);
      this.viewport.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(event.clientY - drag.y) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.viewport.setPointerCapture(event.pointerId);
          this.viewport.classList.add('ruc-is-dragging');
        }
        event.preventDefault();
        this.viewport.scrollLeft = drag.left - dx;
      }, options);
      const finishDrag = event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        this.suppressClick = this.drag.moved;
        this.drag = null;
        this.viewport.classList.remove('ruc-is-dragging');
        if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
      };
      window.addEventListener('pointerup', finishDrag, options);
      window.addEventListener('pointercancel', finishDrag, options);
      this.viewport.addEventListener('lostpointercapture', finishDrag, options);
      this.viewport.addEventListener('dragstart', event => event.preventDefault(), options);
      this.viewport.addEventListener('click', event => {
        if (!this.suppressClick || event.detail === 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }, { ...options, capture: true });
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.viewport);
      this.allSlides.forEach(slide => this.observer.observe(slide));
      this.measure();
    }
    offset(slide) {
      return slide.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left + this.viewport.scrollLeft;
    }
    measure() {
      this.slides = Array.from(this.track.querySelectorAll('[data-ruc-slide]'));
      const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const positions = [];
      this.slides.forEach(slide => {
        const position = Math.min(max, Math.max(0, this.offset(slide)));
        if (!positions.length || position - positions[positions.length - 1] > 2) positions.push(position);
      });
      if (max > 2 && max - (positions[positions.length - 1] || 0) > 2) positions.push(max);
      this.positions = positions;
      if (this.targetIndex !== null) this.targetIndex = Math.min(this.targetIndex, Math.max(0, positions.length - 1));
      this.controls.hidden = max <= 2 || positions.length < 2;
      this.viewport.classList.toggle('ruc-is-draggable', !this.controls.hidden);
      if (this.dots.children.length !== positions.length) {
        this.dots.replaceChildren(...positions.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ruc-dot';
          dot.dataset.position = index;
          dot.setAttribute('aria-label', `Go to carousel position ${index + 1} of ${positions.length}`);
          dot.setAttribute('aria-controls', this.viewport.id);
          return dot;
        }));
      }
      this.update();
    }
    update() {
      this.active = this.positions.reduce((best, position, index) => Math.abs(position - this.viewport.scrollLeft) < Math.abs(this.positions[best] - this.viewport.scrollLeft) ? index : best, 0);
      Array.from(this.dots.children).forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.active)));
    }
    go(index, instant = false) {
      if (!this.positions.length) return;
      const target = (index + this.positions.length) % this.positions.length;
      this.targetIndex = target;
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => { this.targetIndex = null; this.update(); }, 800);
      this.viewport.scrollTo({ left: this.positions[target], behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.settleTimer);
      this.frame = 0;
      this.drag = null;
      this.viewport?.classList.remove('ruc-is-dragging');
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section--hero-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  let slides = document.querySelectorAll('.banner-slide');
  let dots = document.querySelectorAll('.dot');
  let index = 0;

  function showSlide(i) {
    slides.forEach((s, n) => {
      s.classList.toggle('active', n === i);
      dots[n].classList.toggle('active', n === i);
    });
  }

  const next = () => {
    index = (index + 1) % slides.length;
    showSlide(index);
  };

  let interval = setInterval(next, 7000);

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      clearInterval(interval);
      showSlide(i);
      index = i;
      interval = setInterval(next, 10000);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
